import React, { useEffect, useState } from 'react';
import './MediaPage.css';

const youtubeVideos = [
    { title: "Contrôle Semelle - Chronique nantaise de l'été 2020 /// Le Documentaire", url: "https://www.youtube.com/embed/ghSpEyKtADQ" },
    { title: "Contrôle Semelle, l'émission - Episode 1", url: "https://www.youtube.com/embed/Q7HoadtlaNw" },
    { title: "Contrôle Semelle, l'émission - Episode 2", url: "https://www.youtube.com/embed/3BN_WxMW6fI" },
    { title: "Contrôle Semelle, l'émission - Episode 3", url: "https://www.youtube.com/embed/8GMYa9Ln6XI" },
];

const MediaPage = () => {
    const [images, setImages] = useState([]);
    const [visibleCount, setVisibleCount] = useState(12);
    const [selectedImage, setSelectedImage] = useState(null);

    const shuffleArray = (array) => {
        for (let i = array.length - 1; i > 0; i--) {
            const j = Math.floor(Math.random() * (i + 1));
            [array[i], array[j]] = [array[j], array[i]];
        }
        return array;
    };

    const generateRandomImages = (count) => {
        const images = [];
        for (let i = 1; i <= count; i++) {
            images.push({
                id: i,
                src: require(`../assets/images/gallery/photo${i}.webp`),
                alt: `Photo ${i}`,
            });
        }
        return shuffleArray(images);
    };

    useEffect(() => {
        const randomizedImages = generateRandomImages(25);
        setImages(randomizedImages);
    }, []);

    const loadMoreImages = () => {
        setVisibleCount((prevCount) => prevCount + 8);
    };

    const openImage = (image) => setSelectedImage(image);
    const closeImage = () => setSelectedImage(null);

    return (
        <div className="media-page">
            {/* Section Documentaire */}
            <div className="documentary-section">
                <h2 className="section-title">Documentaire Contrôle Semelle</h2>
                <div className="documentary-container">
                    <iframe
                        width="100%"
                        height="350"
                        src={youtubeVideos[0].url}
                        title={youtubeVideos[0].title}
                        frameBorder="0"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                        allowFullScreen
                    ></iframe>
                    <p className="video-title">{youtubeVideos[0].title}</p>
                </div>
            </div>

            {/* Section Émission */}
            <div className="show-section">
                <h2 className="section-title">Émission Contrôle Semelle</h2>
                <div className="video-grid centered-grid">
                    {youtubeVideos.slice(1).map((video, index) => (
                        <div key={index} className="video-card">
                            <iframe
                                width="100%"
                                height="200"
                                src={video.url}
                                title={video.title}
                                frameBorder="0"
                                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                allowFullScreen
                            ></iframe>
                            <p className="video-title">{video.title}</p>
                        </div>
                    ))}
                </div>
            </div>

            {/* Section Galerie Photos */}
            <div className="photo-section">
                <h2 className="section-title">Galerie Photos</h2>
                <div className="gallery-grid">
                    {images.slice(0, visibleCount).map((image) => (
                        <div
                            key={image.id}
                            className="gallery-item"
                            onClick={() => openImage(image)}
                        >
                            <img src={image.src} alt={image.alt} className="gallery-image" />
                        </div>
                    ))}
                </div>
                {visibleCount < images.length && (
                    <button className="load-more-button" onClick={loadMoreImages}>
                        Voir Plus
                    </button>
                )}
                {selectedImage && (
                    <div className="lightbox" onClick={closeImage}>
                        <span className="close-btn">&times;</span>
                        <img src={selectedImage.src} alt={selectedImage.alt} className="lightbox-image" />
                    </div>
                )}
            </div>
        </div>
    );
};

export default MediaPage;
